export class Confidence {
    relevanceLevel: string;
    confidenceLevel: string;
}